module.exports = __webpack_public_path__ + "static/img/hnxyds.053ce74.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/hnxyds.png
// module id = UdHs
// module chunks = 0